import React, { useEffect, useState } from 'react';
import { Loading } from 'react-style-guide';
import { withTranslations, WithTranslationsProps } from 'react-utilities';
import { carouselTranslationConfig } from '../translation.config';
import { TCarouselItem } from '../types/carouselTypes';
import CarouselComponent from '../components/Carousel';
import metadataConstants from '../constants/metadataConstants';
import assetService from '../services/carouselService';

export const Carousel = ({ translate }: WithTranslationsProps): JSX.Element => {
  const { universeId = '' } = metadataConstants.metadataData();
  const [assets, setAssets] = useState<TCarouselItem[] | undefined>(undefined);

  useEffect(() => {
    const fetchAssets = async () => {
      const universeNumber = parseInt(universeId, 10);
      if (!Number.isNaN(universeNumber)) {
        try {
          const carouselItems = await assetService.getUniverseAssetIds(universeNumber);
          setAssets(carouselItems);
        } catch {
          setAssets([]);
        }
      }
    };

    // eslint-disable-next-line no-void
    void fetchAssets();
  }, [universeId]);
  if (assets === undefined) {
    return <Loading />;
  }
  if (assets.length === 0) {
    return <div className='icon-pending' />;
  }
  return <CarouselComponent translate={translate} items={assets} />;
};

export default withTranslations(Carousel, carouselTranslationConfig);
